import { ReactElement, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { windowScrollTop } from 'syf-js-utilities'
import { ScrollToTopProps } from './typing'

const ScrollToTop = ({
  children,
  location: { pathname }
}: ScrollToTopProps): ReactElement => {
  useEffect((): void => {
    windowScrollTop()
  }, [pathname])

  return children
}

export default withRouter(ScrollToTop)
